export default "/images/framework/MyGameRankingCht.415edd9b.svg?415edd9b";